<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap>
      <v-toolbar>
        <v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly">
          {{ $t('reports.reports_title') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-container
        fluid
        elevation-2
        style="max-height: 75vh"
        class="scrollDesign"
      >
        <v-layout row wrap>
          <v-flex
            xs12
            sm6
            md6
            lg4
            v-if="
              userPermissions[
                possibleUserModulePermissions.WATCH_REPORTS_CAPACITY
              ]
            "
          >
            <v-card
              class="elevation-0 expandableContainer zoomR"
              to="reports/Aforo"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/Temperatura.png')"
                aspect-ratio="2.75"
              >
                <v-container fluid pa-2>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        {{ $t('reports.capacity_report_title') }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div style="margin-bottom: 19px">
                    {{ $t('reports.capacity_report_details') }}
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <span>Detalles</span>
                </v-tooltip>
                <!--<<v-btn style="padding: 0px" flat color="primary" >Ver</v-btn>
                  v-btn style="padding: 0px" flat color="primary" to="reports/student-entries">Alumnos</v-btn>
                  <v-btn style="padding: 0px" flat color="primary" to="reports/collaborator-entries">Colaboradores</v-btn>
                  <v-btn style="padding: 0px" flat color="primary" to="reports/parent-entries">Tutores</v-btn>
                  <v-btn style="padding: 0px" flat color="primary" to="reports/visit-entries">Visitas</v-btn>-->
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex
            flexbox
            xs12
            sm6
            md6
            lg4
            v-if="
              userPermissions[
                possibleUserModulePermissions.WATCH_REPORTS_ENTRIES
              ]
            "
          >
            <v-card
              class="elevation-0 expandableContainer zoomR"
              to="reports/Historic"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/ReporteAforo.png')"
                aspect-ratio="2.75"
              >
                <v-container fluid pa-2>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        {{ $t('reports.check_in_and_check_out_report_title') }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div style="text-align: left">
                    {{ $t('reports.check_in_and_check_out_report_details') }}
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <span>Detalles</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex
            flexbox
            xs12
            sm6
            md6
            lg4
            v-if="
              userPermissions[
                possibleUserModulePermissions.WATCH_REPORTS_DELIVERIES
              ]
            "
          >
            <v-card
              class="elevation-0 expandableContainer"
              to="reports/outings"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/reporte-salidas.png')"
                aspect-ratio="2.75"
              >
                <v-container>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        {{ $t('reports.delivery_report_title') }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div style="margin-bottom: 18px">
                    Registro de entrega de alumnos y estatus de solicitudes
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <span>Detalles</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex
            flexbox
            xs12
            sm6
            md6
            lg4
            v-if="
              userPermissions[
                possibleUserModulePermissions.WATCH_REPORTS_EVENTS
              ]
            "
          >
            <v-card
              class="elevation-0 expandableContainer"
              @click="reportNotices"
              role="button"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/Reporte-Eventos.png')"
                aspect-ratio="2.75"
              >
                <v-container>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        {{ $t('reports.event_registration_title') }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div>
                    {{ $t('reports.event_registration_details') }}
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <!-- <v-btn icon ripple slot="activator" to="reports/details">
										<v-icon color="primary">remove_red_eye</v-icon>
                  </v-btn>-->
                  <span>Detalles</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex
            flexbox
            xs12
            sm6
            md6
            lg4
            v-if="
              userPermissions[
                possibleUserModulePermissions.WATCH_REPORTS_ATTENDANCE
              ]
            "
          >
            <v-card
              class="elevation-0 expandableContainer"
              to="reports/Attendance"
              role="button"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/reporte-asistencia.png')"
                aspect-ratio="2.75"
              >
                <v-container>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        Reporte de Asistencia
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div>Registro histórico de asistencia de los alumnos</div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <!-- <v-btn icon ripple slot="activator" to="reports/details">
										<v-icon color="primary">remove_red_eye</v-icon>
                  </v-btn>-->
                  <span>Detalles</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex
            flexbox
            xs12
            sm6
            md6
            lg4
            v-if="
              userPermissions[
                possibleUserModulePermissions
                  .WATCH_REPORTS_ATTENDANCE_COLLABORATOR
              ]
            "
          >
            <v-card
              class="elevation-0 expandableContainer"
              to="reports/collaborators_attendance"
              role="button"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/collaborators_attendance.png')"
                aspect-ratio="2.75"
              >
                <v-container>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        Reporte de Asistencia de colaboradores
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div>
                    Registro histórico de asistencia de los colaboradores
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <span>Detalles</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex
            flexbox
            xs12
            sm6
            md6
            lg4
            v-if="
              userPermissions[
                possibleUserModulePermissions.WATCH_REPORTS_THIRDQR
              ]
            "
          >
            <v-card
              class="elevation-0 expandableContainer"
              to="reports/third_authorizations"
              role="button"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/report_third_auth.png')"
                aspect-ratio="2.75"
              >
                <v-container>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        Reporte de permisos de terceros
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div>
                    Reporte de permisos de terceros autorizados por los tutores
                  </div>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md6 lg4 v-if="!isNormalSchool()">
            <v-card
              class="elevation-0 expandableContainer"
              to="reports/Workshopreport"
            >
              <v-img
                :src="require('@/assets/reports/reporte-talleres.png')"
                aspect-ratio="2.75"
              >
                <v-container>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        Reporte de asistencias
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div>Visualiza las asistencias de los talleres</div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <!-- <v-btn icon ripple slot="activator" to="reports/details">
                                        <v-icon color="primary">remove_red_eye</v-icon>
                  </v-btn>-->
                  <span>Detalles</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex
            flexbox
            xs12
            sm6
            md6
            lg4
            v-if="
              userPermissions[
                possibleUserModulePermissions.WATCH_REPORTS_SCHOOL_TRANSPORT
              ]
            "
          >
            <v-card
              class="elevation-0 expandableContainer"
              to="reports/school_transportation"
              role="button"
              style="height: 100%"
            >
              <v-img
                :src="require('@/assets/reports/school_transportation.png')"
                aspect-ratio="2.75"
              >
                <v-container>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">
                        Reporte de transporte escolar
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div>Registro de las rutas del transporte escolar</div>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>

          <!--<v-flex xs12 sm6 md6 lg4>
            <v-card class="elevation-0 expandableContainer">
              <v-img :src="require('@/assets/reports/slides_2,2.jpg')" aspect-ratio="2.75">
                <v-container fluid pa-2>
                  <v-layout>
                    <v-flex flexbox>
                      <span class="headline white--text">Reporte de asistencia</span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>

              <v-card-title primary-title>
                <div>
                  <div>Reporte de asistencia de alumnos de la institución, agrupados por niveles, en el rango de fechas señalado</div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip right>
                  <v-btn icon ripple slot="activator" to="reports/details">
										<v-icon color="primary">remove_red_eye</v-icon>
                  </v-btn>
                  <span>Detalles</span>
                </v-tooltip>
                <v-btn flat color="primary" @click="reportAttendance">Descargar</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>-->
        </v-layout>
        <EventsReports
          v-on:close="closeEvents"
          v-model="modals.events"
          :value="modals.events"
        ></EventsReports>
        <DeliverReports
          v-on:close="closeDelivers"
          v-model="modals.delivers.show"
          :value="modals.delivers.show"
          :body="modals.delivers.body"
        ></DeliverReports>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { isNormalSchool } from '../../../plugins/GeneralMethods.js'
import { _getUserPermissions } from '../../../utils/genericUtils.js'
import DeliverReports from '../../Modals/DeliverReportsModal.vue'
import EventsReports from '../../Modals/EventReportsModal.vue'

export default {
  components: {
    EventsReports,
    DeliverReports,
  },
  props: [],
  data: () => ({
    modals: {
      events: false,
      delivers: {
        show: false,
        body: {},
      },
    },
    toast: {
      success: false,
      failed: false,
    },
    working: {
      wLoading: false,
    },
    userPermissions: {},
    possibleUserModulePermissions: {
      WATCH_REPORTS_CAPACITY: 'WATCH_REPORTS_CAPACITY',
      WATCH_REPORTS_ENTRIES: 'WATCH_REPORTS_ENTRIES',
      WATCH_REPORTS_DELIVERIES: 'WATCH_REPORTS_DELIVERIES',
      WATCH_REPORTS_EVENTS: 'WATCH_REPORTS_EVENTS',
      WATCH_REPORTS_ATTENDANCE: 'WATCH_REPORTS_ATTENDANCE',
      WATCH_REPORTS_ATTENDANCE_COLLABORATOR:
        'WATCH_REPORTS_ATTENDANCE_COLLABORATOR',
      WATCH_REPORTS_THIRDQR: 'WATCH_REPORTS_THIRDQR',
      WATCH_REPORTS_SCHOOL_TRANSPORT: 'WATCH_REPORTS_SCHOOL_TRANSPORT',
    },
  }),
  mounted() {
    if (this.getUser.id) {
      this.mapPermits()
    }
  },
  watch: {
    getUser() {
      this.mapPermits()
    },
  },
  methods: {
    isNormalSchool() {
      return isNormalSchool(this.getBranch)
    },
    reportNotices() {
      this.modals.events = true
    },
    closeEvents(val) {
      this.modals.events = val
    },
    closeDelivers(val) {
      this.modals.delivers.show = val
      this.modals.delivers.body = {}
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.onCancel()
      }
    },
    onCancel() {
      this.modals.events = false
      this.modals.delivers.show = false
      this.$forceUpdate()
    },
    mapPermits() {
      this.userPermissions = _getUserPermissions({
        getUser: this.getUser,
        possibleUserModulePermissions: this.possibleUserModulePermissions,
      })
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
  computed: {
    ...mapGetters(['getBranch', 'getUser']),
  },
}
</script>
<style>
.no-padding {
  padding-left: 10%;
}
.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}
.expandableContainer {
  border-style: solid !important;
  border-color: #e6e6e6 !important;
  border-radius: 15px !important;
  border-width: 2px !important;
}
</style>
